if (!customElements.get('monogram-embroidery')) {
  customElements.define(
    'monogram-embroidery',
    class MonogramEmbroidery extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.section;
        this.maxLen = parseInt(this.dataset.max, 10) || 3;
        this.requireInitials = this.dataset.require !== 'false';
        this.feeVariantId = this.dataset.feeVariantId ? parseInt(this.dataset.feeVariantId, 10) : null;
        this.fallbackVariantId = this.dataset.variantId ? parseInt(this.dataset.variantId, 10) : null;

        this.form = document.getElementById(this.dataset.formId);
        this.initialsInput = this.querySelector('[data-monogram-initials-input]');
        this.counter = this.querySelector('[data-monogram-counter]');
        this.threadButtons = Array.from(this.querySelectorAll('[data-monogram-thread]'));
        this.preview = this.querySelector('[data-monogram-preview]');
        this.previewInitials = this.querySelector('[data-monogram-preview-initials]');
        this.errorEl = this.querySelector('[data-monogram-error]');
        this.addButton = this.querySelector('[data-monogram-add]');

        const selected = this.threadButtons.find((b) => b.classList.contains('is-selected')) || this.threadButtons[0];
        this.thread = selected
          ? { label: selected.dataset.threadLabel, color: selected.dataset.threadColor }
          : { label: '', color: '#000000' };

        if (this.initialsInput) this.initialsInput.addEventListener('input', this.onInitialsInput.bind(this));
        this.threadButtons.forEach((b) => b.addEventListener('click', () => this.onSelectThread(b)));
        if (this.addButton) this.addButton.addEventListener('click', this.onAddToOrder.bind(this));

        this.render();
      }

      sanitize(value) {
        return (value || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, this.maxLen);
      }

      currentInitials() {
        return this.sanitize(this.initialsInput ? this.initialsInput.value : '');
      }

      onInitialsInput() {
        const clean = this.sanitize(this.initialsInput.value);
        if (this.initialsInput.value !== clean) this.initialsInput.value = clean;
        if (this.errorEl && clean.length > 0) this.errorEl.hidden = true;
        this.render();
      }

      onSelectThread(button) {
        this.threadButtons.forEach((b) => {
          const on = b === button;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        this.thread = { label: button.dataset.threadLabel, color: button.dataset.threadColor };
        this.render();
      }

      render() {
        const initials = this.currentInitials();
        if (this.counter) this.counter.textContent = `${initials.length} / ${this.maxLen}`;
        if (this.previewInitials) {
          this.previewInitials.textContent = initials || 'ABC';
          this.previewInitials.classList.toggle('is-placeholder', initials.length === 0);
        }
        if (this.preview) this.preview.style.setProperty('--monogram-thread', this.thread.color);
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      garmentVariantId() {
        if (this.form) {
          const idInput = this.form.querySelector('[name="id"]');
          if (idInput && idInput.value) return parseInt(idInput.value, 10);
        }
        return this.fallbackVariantId;
      }

      garmentQuantity() {
        const qtyInput = document.getElementById(`Quantity-${this.sectionId}`);
        const q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        return q && q > 0 ? q : 1;
      }

      onAddToOrder() {
        const initials = this.currentInitials();
        if (this.requireInitials && initials.length === 0) {
          this.showError(`Please enter 1–${this.maxLen} initials.`);
          if (this.initialsInput) this.initialsInput.focus();
          return;
        }

        const garmentId = this.garmentVariantId();
        if (!garmentId) {
          this.showError('This item is currently unavailable.');
          return;
        }

        const qty = this.garmentQuantity();
        const ref = `mg-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const items = [
          {
            id: garmentId,
            quantity: qty,
            properties: { Initials: initials, 'Thread Color': this.thread.label, _monogram_ref: ref },
          },
        ];
        if (this.feeVariantId) {
          items.push({
            id: this.feeVariantId,
            quantity: qty,
            properties: {
              _monogram_fee: '1',
              _monogram_ref: ref,
              _monogram_for: initials,
              _monogram_thread_label: this.thread.label,
              _monogram_thread_color: this.thread.color,
            },
          });
        }

        this.setLoading(true);
        const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];

        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || 'Could not add to cart.');
              return;
            }
            // Mirror product-form.js: the drawer root keeps `is-empty` from an
            // empty-cart page load; without removing it the CSS hides the
            // freshly rendered header/items and the drawer opens blank.
            if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            if (drawer && drawer.renderContents) drawer.renderContents(response);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'monogram', cartData: response });
            this.reset();
          })
          .catch((error) => {
            console.error('[monogram] add failed', error);
            this.showError('Could not add to cart. Please try again.');
          })
          .finally(() => this.setLoading(false));
      }

      setLoading(on) {
        if (!this.addButton) return;
        this.addButton.disabled = on;
        this.addButton.toggleAttribute('aria-busy', on);
      }

      reset() {
        if (this.initialsInput) this.initialsInput.value = '';
        if (this.errorEl) this.errorEl.hidden = true;
        this.render();
      }
    }
  );
}
